import { createAction } from 'redux-actions';
import { normalize } from 'normalizr';
import { push } from '@lagunovsky/redux-react-router';
import { pick } from 'ramda';

import { db } from '../firebase';
import categorySchema, { categories as categoriesSchema } from '../schema/category';
import { addDoc, collection, doc, getDoc, getDocs, query, updateDoc } from 'firebase/firestore';

const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
const FETCH_CATEGORIES_FAILED = 'FETCH_CATEGORIES_FAILED';

const FETCH_CATEGORY_REQUEST = 'FETCH_CATEGORY_REQUEST';
const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
const FETCH_CATEGORY_FAILED = 'FETCH_CATEGORY_FAILED';

const CREATE_CATEGORY_REQUEST = 'CREATE_CATEGORY_REQUEST';
const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
const CREATE_CATEGORY_FAILED = 'CREATE_CATEGORY_FAILED';

const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST';
const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
const UPDATE_CATEGORY_FAILED = 'UPDATE_CATEGORY_FAILED';

const fetchCategoriesRequest = createAction(FETCH_CATEGORIES_REQUEST);
const fetchCategoriesSuccess = createAction(FETCH_CATEGORIES_SUCCESS);
const fetchCategoriesFailed = createAction(FETCH_CATEGORIES_FAILED);

const fetchCategoryRequest = createAction(FETCH_CATEGORY_REQUEST);
const fetchCategorySuccess = createAction(FETCH_CATEGORY_SUCCESS);
const fetchCategoryFailed = createAction(FETCH_CATEGORY_FAILED);

const createCategoryRequest = createAction(CREATE_CATEGORY_REQUEST);
const createCategorySuccess = createAction(CREATE_CATEGORY_SUCCESS);
const createCategoryFailed = createAction(CREATE_CATEGORY_FAILED);

const updateCategoryRequest = createAction(UPDATE_CATEGORY_REQUEST);
const updateCategorySuccess = createAction(UPDATE_CATEGORY_SUCCESS);
const updateCategoryFailed = createAction(UPDATE_CATEGORY_FAILED);

export const getCategories = () => {
  return dispatch => {
    dispatch(fetchCategoriesRequest());

    getDocs(
        query(collection(db, 'categories'))
      )
      .then(snapshot => {
        const categories = snapshot.docs
          .map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        
        dispatch(fetchCategoriesSuccess({ ...normalize(categories, categoriesSchema) }));
      })
      .catch(error => {
        dispatch(fetchCategoriesFailed({
          notie: { type: 'error', message: error },
        }));
      });
  }
};

export const getCategory = (id) => {
  return dispatch => {
    dispatch(fetchCategoryRequest());

    getDoc(doc(db, 'categories', id))
      .then(doc => {
        const category = doc.exists()
          ? Object.assign({}, { id: doc.id }, doc.data())
          : {};

        dispatch(fetchCategorySuccess({
          ...normalize(category, categorySchema)
        }));
      })
      .catch(error => {
        dispatch(fetchCategoryFailed({
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const createCategory = (ctgr) => {
  return dispatch => {
    dispatch(createCategoryRequest());

    addDoc(
        collection(db, 'categories'),
        ctgr
      )
      .then(ref => Object.assign({}, { id: ref.id }, ctgr))
      .then(category => {
        dispatch(createCategorySuccess( { ...normalize(category, categorySchema) }))
        dispatch(push('/admin/categories'));
      })
      .catch(error => dispatch(createCategoryFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const updateCategory = (id, ctgr) => {
  return dispatch => {
    dispatch(updateCategoryRequest());

    const data = pick(['name', 'description'], ctgr);

    updateDoc(
        doc(db, 'categories', id),
        data
      )
      .then(() => {
        dispatch(updateCategorySuccess( { ...normalize(ctgr, categorySchema) }))
        dispatch(push('/admin/categories'));
      })
      .catch(error => dispatch(updateCategoryFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const actions = {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILED,
  FETCH_CATEGORY_REQUEST,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILED,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILED,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILED,
};
